import { createSlice } from "@reduxjs/toolkit";
import { fetchUserProfile } from "../userManagementApi";

const fetchUserProfileSlice = createSlice({
    name: "fetchUserProfile",
    initialState: {
        data: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchCommunityData cases
            .addCase(fetchUserProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchUserProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default fetchUserProfileSlice.reducer;
